module.exports = __webpack_public_path__ + "img/nigeria_icon.7b3173c2.svg";